import React from 'react';

const ProblemSection = () => {
  return (
    <section className="py-24 bg-white" data-testid="problem-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-gray-900 mb-6">
          Building can feel <span className="gradient-text">overwhelming</span>.
        </h2>
        <p className="text-xl text-gray-500 max-w-2xl mx-auto leading-relaxed">
          Costs change. Timelines shift. Advice is often inconsistent. BuildPilot App gives you a clear view of your project so you can make informed decisions before issues arise.
        </p>
      </div>
    </section>
  );
};

export default ProblemSection;
